// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"890a218b","345":"2da91763","453":"20359781","777":"c1e27506"}[chunkId] + ".chunk.js";
};